import AccordionList from "../components/AccordionList";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import TestimonialGrid from "../components/TestimonialGrid";

export default function PresentationSkillsAdult() {
  const testi = [
    {
      name: "Rebecca Ng",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            I recently attended the public speaking class conducted by Darren
            and it was a transformative experience. He provided practical
            strategies to overcome stage fright and boost confidence, creating a
            supportive environment that encouraged all of us to step out of our
            comfort zones.
            <br />
            <br />
            One of the biggest takeaways was learning to connect with my
            audience authentically. Through interactive exercises and
            personalized feedback, I felt my stage presence and speaking skills
            grow stronger with each session. The class was well-structured,
            balancing theory with real practice, and the feedback was
            constructive and actionable.
            <br />
            <br />
            I’d highly recommend this class to anyone looking to enhance their
            public speaking skills or improve their confidence when addressing
            an audience. It’s more than just learning to speak—it’s about
            developing charisma and poise that resonate beyond the stage.
          </p>
        </>
      ),
    },
    {
      name: "Marc Betz",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            I recently attended a 2-day public speaking course with the Public
            Speaking Academy, and it was an excellent experience. The course
            offered numerous opportunities for engagement, hands-on learning,
            and practical tools to enhance public speaking skills. The trainers
            provided valuable guidance throughout, making the sessions
            interactive and supportive. I highly recommend this course for
            anyone looking to boost their confidence and polish their
            presentation abilities
          </p>
        </>
      ),
    },
    {
      name: "Chin Hock Tan",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            Just completed a 2-day Speech Performance Program for Adults
            conducted by Darren and Zul. Have learned a great deal about speech
            structures, received valuable guidance, and gained numerous
            actionable tips to enhance my presentations. Both trainers
            demonstrated extensive knowledge, exceptional patience, and the
            ability to address all our questions, from preparation to the actual
            delivery of presentations, keynote speeches, and even impromptu
            talks.
            <br />
            <br />
            In addition to theoretical insights, practical speaking sessions
            were conducted for each of us, followed by detailed analysis by the
            trainers. I highly recommend this 2-day course to anyone looking to
            improve their presentation and speech delivery skills.
          </p>
        </>
      ),
    },
    {
      name: "Carollyne Tong",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            I am a public speaker and a WSQ ACLP trainer. I have seen Darren
            Tay's videos and acknowledged his public speaking skill as he was
            the 2016 Ted talk champion. I was prompted to join his 2 days Public
            speaking program because I want to learn from the subject expert and
            I believed he is the best in public speaking. The program was
            comprehensive with notes given, but most importantly is that it is
            not just theory-based but there are many sessions of practical
            presentation which valuable feedback were given for our improvement.
            Darren is selfless in sharing all the theories and secrets for
            public speaking and he is really good, almost everything is at his
            fingertips when he taught us.
            <br />
            <br />
            We also had Mugan coming in to guide us on body language. He is also
            committed in bringing across this subject and injects fun into the
            sessions. He is experienced and had his own style in delivering.
            Overall, this is the course that I will recommend to anyone who is
            lack of confidence or have fear speaking in front of people. After
            the 2 days, you will definitely see your own improvement. If I can
            see my own improvements and benefits, so can you.
          </p>
        </>
      ),
    },
    {
      name: "kaylee nutnut nutnut",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            Extremely professional trainers who are worth every dollar. So much
            tips and information within 2 days comprehensive course. Definitely
            recommend to everyone!
          </p>
        </>
      ),
    },
    {
      name: "Francis Tan",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            I have just attended a 2-day public speaking course with Public
            Speaking Academy and i must say that i thoroughly enjoyed myself
            learning all the fun facts about how to do well in public speaking.
            The many tips, techniques, dos and don'ts were clearly explained
            with many examples shared with personal anecdotes given. I am sure
            anyone attending this course will not regret signing up for it.
          </p>
        </>
      ),
    },
    {
      name: "Julie Schappler",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            I participated to the 2-days Public Speaking Bootcamp at the Public
            Speaking Academy in Singapore. Darren Tay, as master trainer and his
            team, gave us insightful advices and knowledge on several topics:
            impromptus speech, pitch elevator, negotiation, story telling, small
            talk, interpersonal communication, body language, prononciation,
            etc. Most importantly we were explained WHY these tips are efficient
            in real life and HOW to implement them. We were able to try them out
            with several hands on activities. All of them were video recorded
            and we had immediate feedback from the trainers, from positive
            points to improvements to make.
            <br />
            <br />I participated to many workshops on this topic before, this
            one was the first one dealing with all aspects in ONE training and
            with so many activities and feedbacks. The articulation of the
            bootcamp is perfect, and booster sessions in the coming months are
            comprised in the package. I highly recommend anyone to attend the
            Public Speaking Academy, regardless of age, occupation, and aim. It
            will be useful throughout your entire (private and professional)
            life.
          </p>
        </>
      ),
    },
    {
      name: "Bee Lay Tan",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            Attending the public speaking course was such an eye opening
            experience. The well-structured curriculum and engaging instructors
            (Thanks Darren and Zul!) not only boosted my confidence but also
            equipped me with valuable techniques to articulate ideas
            effectively. I loved the interactive sessions and constructive
            feedback that fostered a supportive learning environment the past 2
            days. I highly recommend this course to anyone looking to hone their
            public speaking abilities! 👍🏼👍🏼👍🏼
          </p>
        </>
      ),
    },
    // Add more testimonials as needed
  ];

  const faqData = [
    {
      title:
        "Best public speaking classes in Singapore for managers who need to present to stakeholders.",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            🧑💼 Speak Like a Leader (with influence)
          </p>
          <p className="p-1">
            Our Public Speaking Program is tailored for mid- to senior-level
            managers or executives who need to persuade, align, and inspire.
            Learn how to speak with authority, handle Q&A confidently, and
            deliver clear messages to stakeholders — whether in meetings,
            boardrooms, or investor pitches.
          </p>
        </>
      ),
    },
    {
      title:
        "How to overcome stage fright before giving a work presentation — any workshops in Singapore?",
      content: (
        <>
          <p className="p-1 text-lg font-bold">😨 Nervous? You’re Not Alone.</p>
          <p className="p-1">
            73% of adults fear public speaking. Our World Champion Certification
            Program™ and S’Peak Performance Adult Masterclass™ are designed with
            training modules that use cognitive-behavioral strategies (such as
            teaching speech structures that allow reflex-like formulation of
            speeches/ responses to impromptu questions/ presentations Q&A),
            breathing exercises, and simulated speaking challenges to help you
            become calm, clear, and confident in front of any audience.
          </p>
        </>
      ),
    },
    {
      title:
        "What’s the ROI of public speaking training for entrepreneurs or executives pitching to investors/ audiences?",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            💸 Pitch Perfect: ROI You Can Measure (Qualitatively &
            Quantitatively)
          </p>
          <p className="p-1">
            Our World Champion Certification Program™ and S’Peak Performance
            Adult Masterclass™ focus on persuasive storytelling, value framing,
            and clear & structured presentations to project authority — the
            marked reduction in speech anxiety and effective workplace
            communication may be measured qualitatively, but the increase in
            collaborations and deals closed because of the enhancement of
            persuasive storytelling skills and pitching/ interview skills can be
            measured quantitatively.
          </p>
        </>
      ),
    },
    {
      title:
        "Where can I learn persuasive public speaking and storytelling for sales in Singapore?",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            💬 Storytelling for Sales Success
          </p>
          <p className="p-1">
            Selling isn’t just about features — it’s about stories that connect.
            Our World Champion Certification Program™ and S’Peak Performance
            Adult Masterclass™ are designed with modules that teach sales
            professionals how to craft persuasive narratives, weave engaging
            stories in speeches, and formulate impromptu speeches to manage
            difficult queries from prospects — all through the lens of confident
            communication.
          </p>
        </>
      ),
    },
    {
      title:
        "Compare executive public speaking & presentation courses at other training providers and Public Speaking Academy",
      content: (
        <>
          <p className="p-1 text-lg font-bold">🔎 How We Compare</p>
          <p className="p-1">
            Unlike larger institutions, our class sizes are small (max 12 pax)
            yet provides the critical exposure needed from a sizable audience to
            hone eloquence & confidence, ensuring personalized coaching. While
            other providers may focus on English language and offer general
            skills, our programs specialize in persuasive speaking, high-stakes
            presentation, and confidence-building — ideal for executives and
            entrepreneurs.
          </p>
        </>
      ),
    },
    {
      title: "How to overcome public speaking anxiety and build confidence",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            💬 Essential blend: Theory (techniques), Practice (the right
            approach), Guidance (experienced trainers with perceptive
            evaluation)
          </p>
          <p className="p-1">
            Just a guidebook or textbook on public speaking is not going to
            work. A public speaking workshop, presentation course/ programme can
            help — like our World Champion Certification Program™ and S’Peak
            Performance Adult Masterclass™ which use exposure therapy,
            structured practice, and expert feedback{" "}
            <a
              className="text-btnColor"
              href="https://www.publicspeakingacademy.com.sg/senior-trainers-trainers"
            >
              (trainers’ profile)
            </a>{" "}
            to build confidence over time. Our public speaking courses are
            designed to incrementally help our adult learners be comfortable and
            confident in presenting in front of a small but sizable group (12 to
            17 pax), through the multiple speaking opportunities and exposures,
            coupled with techniques and strategies to craft and deliver speeches
            from various genres (persuasive, informative, story-telling,
            emceeing). We strive to impart actionable techniques, provide
            practical opportunities for application and assimilation of
            techniques to better manage the relationship with stage/ speaking
            anxiety.
          </p>
        </>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Presentation Skills Training Course by World Champion | Public
          Speaking Academy
        </title>
        <meta
          name="description"
          content="Find out why we are the preferred choice for effective communication excellence and public speaking course in Singapore. Led by top public speaker, Darren Tay."
        />
      </Helmet>

      <section id="breadcrumb" className="bg-[#F5F5FC] py-1">
        <div className="container mx-auto">
          <div className="flex flex-row justify-between mx-3">
            <div>Presentation Skills Training Course for Adults</div>
            <div>
              Home / Courses & Programs / Public Speaking for Adults / Intensive
              Masterclasses/Bootcamps
            </div>
          </div>
        </div>
      </section>

      <section id="block-1" className="mx-3">
        <div class="container mx-auto py-20">
          <div class="flex flex-col lg:flex-row space-x-10 pt-5">
            <div class="w-full lg:w-2/3">
              <h1 class="font-primary text-3xl font-bold uppercase text-primary">
                Presentation Skills Training Course for Adults
              </h1>
              <h2 class="py-5 font-primary text-2xl font-bold uppercase text-primary">
                2-Day Intensive, Masterclass in Public Speaking & Presentations
              </h2>
              <div>
                <img
                  src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-1-3.png"
                  alt=""
                />
                <p class="py-5 font-text text-lg">
                  “I don’t need public speaking skills.” From the biggest stage
                  to the smallest room, communication and presentation skills
                  remain an important part of our day-to-day routine. You may be
                  delivering a speech before a large audience, giving a business
                  presentation to the board of directors, or motivating your
                  team – all these scenarios require public speaking skills and
                  presentation abilities. We know that you want to be that
                  charismatic, persuasive, and engaging presenter. If you are
                  still looking for that course to improve your business
                  presentation, communication, and public speaking skills, look
                  no further than Public Speaking Academy’s signature intensive
                  public speaking and presentation course for adults -{" "}
                  <strong>S’Peak Performance Programme (adults)!</strong>
                </p>
                <img
                  src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-2-2.png"
                  alt=""
                />

                <p className="pt-5 pb-5 text-xl font-bold">
                  Public Speaking Academy Presents - S’Peak Performance
                  Programme (our signature intensive public speaking &
                  presentation course for adults)
                </p>
                <p className="text-lg font-text">
                  The S’Peak Performance Programme (Adults) is a 2-day intensive
                  bootcamp/ class that offers a deep-dive into public speaking
                  and business presentation techniques, tailored to the modern
                  working adult. We have curated the core components of the
                  programme to cover topics that are essential to your
                  day-to-day at work or home. This unique public speaking and
                  presentation skills training class is helmed personally by our
                  Master Trainer and World Champion of Public Speaking 2016,
                  Darren Tay (assisted by Senior Trainer). The programme is
                  designed with these in mind:
                </p>
                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    Versatile, Relevant, and Implementable Techniques:
                    communication techniques that are immediately relevant to
                    your day-to-day settings (e,g,, business presentations,
                    persuasion)
                  </li>
                  <li className="text-lg font-text">
                    All-Rounded Learning Experience: pathway to advanced soft
                    skills such as leadership, persuasion, or even conflict
                    management, making you an all-rounded presenter
                  </li>
                  <li className="text-lg font-text">
                    World Champion Experience: learning experience designed by
                    our training team, led by Darren Tay, Singapore’s first
                    World Champion of Public Speaking!
                  </li>
                </ul>

                <p class="font-text text-lg">
                  Learn and practise effective communication, public speaking
                  and presentation skills in a safe, constructive, and engaging
                  learning environment.
                </p>

                <div className="bg-slate-50 p-2 md:p-10 mt-10 rounded-3xl">
                  <div className="mb-10">
                    <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                      Frequently Asked Questions (FAQs)
                    </h1>
                  </div>
                  <AccordionList items={faqData} />
                </div>

                <div className="py-10">
                  <h3 className="text-3xl font-bold text-center py-2">
                    The World Champion Masterclass Syllabus
                  </h3>
                  <p className="text-xl font-bold text-center">
                    (a public speaking & presentation skills training bootcamp
                    running since 2016)
                  </p>
                </div>

                <section>
                  <div class="flex flex-col lg:flex-row space-y-10 lg:space-y-0 lg:space-x-10 my-5">
                    <div className="w-full lg:w-1/2">
                      <img src="/images/point-1.png" alt="" />
                      <h1 class="text-3xl font-bold mt-4">
                        Conquering Stage Fright & Enhancing Your Stage Charisma
                      </h1>
                      <p class="font-bold mt-4 text-lg">
                        How do we turn stage fright into stage might? Is it
                        possible to get rid of stage anxiety entirely? Anxiety
                        is a universal human emotion. This means that while we
                        cannot get rid of anxiety entirely (this is the same for
                        even the best speakers in the world), we can change our
                        relationship with it and turn stage fright into stage
                        might.
                      </p>
                      <h3 className="font-bold mt-4 text-lg text-textColor">
                        Here's some things you'll learn in this presentation
                        course:
                      </h3>
                      <ul class="font-bold mt-2 text-lg list-disc list-outside pl-4 text-textColor">
                        <li>
                          Effective power poses you can use to overcome stage
                          fright and business presentation anxieties
                        </li>
                        <li>
                          Step-by-step visualization method to be consistently
                          confident in public speaking settings
                        </li>
                        <li>
                          How to rehearse & practice like the top professional
                          speakers
                        </li>
                      </ul>
                    </div>
                    <div className="w-full lg:w-1/2">
                      <img src="/images/point-2.png" alt="" />
                      <h1 class="font-bold mt-4 text-3xl">
                        Delivering A Winning Business Presentation
                      </h1>
                      <p class="font-bold mt-4 text-lg">
                        Is there a blueprint to winning business presentation?
                        <br />
                        Can I become a proficient public speaker even though I
                        am an introvert?
                        <br />
                        The answer is: Yes you can!
                      </p>
                      <h3 className="font-bold mt-4 text-lg text-textColor">
                        Here some things you'll learn in this presentation
                        skills course:
                      </h3>
                      <ul class="font-bold mt-2 text-lg list-disc list-outside pl-4 text-textColor">
                        <li>How to compose an attention-grabbing story</li>
                        <li>
                          The secrets to delivering powerful powerpoint
                          presentation without reading off the slides
                        </li>
                        <li>
                          The "8-step Edge of the seat" formula that keeps
                          peoples listening attentively plus 2 speech genres
                          (persuasive and informative speech)
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="flex flex-col lg:flex-row space-y-10 lg:space-y-0 lg:space-x-10 my-5">
                    <div className="w-full lg:w-1/2">
                      <img src="/images/point-3.png" alt="" />
                      <h1 class="text-3xl font-bold mt-4">
                        Top Body Language Secrets
                      </h1>
                      <p class="font-bold mt-4 text-lg">
                        Studies have shown that 70% of communication is body
                        language! This is how important non-verbal communication
                        is.
                      </p>
                      <h3 className="font-bold mt-4 text-lg text-textColor">
                        Here's some things you'll learn in this public speaking
                        module:
                      </h3>
                      <ul class="font-bold mt-2 text-lg list-disc list-outside pl-4 text-textColor">
                        <li>
                          Hand gestures,power poses, stage positioning fright
                        </li>
                        <li>
                          How to have stage presence with proper eye contact
                          (learn about the wide angle of attack and eye contact
                          distribution)
                        </li>
                        <li>
                          The power of incorporating pauses in your presentation
                        </li>
                        <li>Facial expressions you should avoid using</li>
                      </ul>
                    </div>
                    <div className="w-full lg:w-1/2">
                      <img src="/images/point-4.png" alt="" />
                      <h1 class="font-bold mt-4 text-3xl">
                        Impromptu Speaking
                      </h1>
                      <p class="font-bold mt-4 text-lg">
                        How to think fast on your feet if you need to speak at
                        the last min:
                      </p>
                      <h3 className="font-bold mt-4 text-lg text-textColor">
                        Here some things you'll learn in this presentation
                        class:
                      </h3>
                      <ul class="font-bold mt-2 text-lg list-disc list-outside pl-4 text-textColor">
                        <li>
                          The P.E.E.L & interrogative pronouns formula that you
                          can use if you've ran out of ideas
                        </li>
                        <li>
                          The P.P.F and the Pendulum model that helps you to
                          speak during 1-on-1 or to a group
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="flex flex-col lg:flex-row space-y-10 lg:space-y-0 lg:space-x-10 my-5 justify-center">
                    <div className="w-full lg:w-1/2">
                      <img src="/images/point-5.png" alt="" />
                      <h1 class="text-3xl font-bold mt-4">
                        Linguistics & Vocal
                      </h1>
                      <h3 className="font-bold mt-4 text-lg text-textColor">
                        Here some things you'll learn in this presentation
                        course:
                      </h3>
                      <ul class="font-bold mt-2 text-lg list-disc list-outside pl-4 text-textColor">
                        <li>
                          How to make use of vocal/tonal speech patterns to make
                          yourself understood faster and better
                        </li>
                        <li>
                          Identify and apply the techniques to avoid commonly
                          mis-pronounced and mis-enunciated words
                        </li>
                        <li>
                          Using rhetorical questions and literacy devices to ace
                          your next presentation
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>

                <p className="mt-10 mb-5 text-xl italic font-bold">
                  The Programme Details - How Do I Sign Up?
                </p>

                <div className="p-5 bg-orange-200 rounded-md ">
                  <h3 class="mb-5 text-center font-primary text-xl font-bold text-primary">
                    Upcoming Cohort
                  </h3>
                  <p className="text-lg text-center ">
                    18 & 19 September 2025 (Thursday & Friday), 9.00 am to 6.00
                    pm on both days (Note: No meals provided)
                  </p>

                  <p className="font-bold text-center text-md">
                    (doors open for attendance from 8.30 to 9 am for both
                    sessions, with class starting strictly at 9 am)
                  </p>
                </div>

                <div className="p-5 my-10 bg-gray-100 rounded-md ">
                  <h3 class="mb-5 text-center font-primary text-xl font-bold text-primary">
                    Price Details
                  </h3>
                  <p className="text-lg py-2">
                    2-day intensive, knowledge-packed, ample practice
                    opportunities training camp/ workshop, conducted personally
                    by the World Champion of Public Speaking Darren Tay
                    (assisted by our Senior Trainer), learning materials (e.g.,
                    printed materials, evaluation forms, certificates of
                    completion) provided – gain effective communication and
                    business presentation skills you can apply immediately!
                  </p>
                  <p className="text-lg py-2">
                    In addition, we will extend free access to our exclusive
                    Facebook Mastermind group (worth $297) – continued access to
                    your World Champion Trainer where you can ask questions
                    directly, AFTER the program, so as to further support you on
                    your journey to becoming an effective presenter!
                  </p>
                  <p className="text-lg font-bold py-2">
                    All in all, we are offering a limited-seats-only rate of –
                    S$997 nett. Register NOW to secure your seat as we go by a
                    first-secured-first-serve basis.
                  </p>
                </div>

                <p className="mt-10 mb-5 text-xl font-bold text-center">
                  Other Key Programme Details
                </p>
                <div className="flex flex-row items-center border-t border-gray-200">
                  <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                    Where is the class conducted?
                  </div>
                  <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                    <b>SAFRA TAMPINES BRANCH</b>
                    <br />
                    Public Speaking Academy @ Tampines <br />
                    1A Tampines Street 92 #01-13B <br />
                    SAFRA Tampines <br />
                    Singapore-528882.
                  </div>
                </div>
                <div className="flex flex-row items-center border-t border-gray-200">
                  <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                    What is the class size?
                    <br />
                    Can I attend a trial?
                  </div>
                  <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                    Maximum class size of 16 – 18 students – as this is an
                    intensive programme with limited capacity, there is no trial
                    class. Likewise, only enrolled students will be allowed to
                    sit in for the programme to ensure a constructive and safe
                    learning environment.
                  </div>
                </div>
                <div className="flex flex-row items-center border-t border-gray-200">
                  <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                    Who are the Trainers?
                  </div>
                  <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                    The programme will be helmed by our Principal/Master Trainer
                    Mr Darren Tay and our Senior Trainer (with each Trainer
                    taking one day content load each).
                  </div>
                </div>
                <div className="flex flex-row items-center border-t border-gray-200">
                  <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                    What if I miss a class or need to leave early?
                  </div>
                  <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                    There is no replacement for the missed session or a
                    refund/pro-rate for the session/portions missed. We
                    recommend learners to confirm their availability for the
                    full programme before signing up (you may instead consider
                    our regular public speaking programme).
                  </div>
                </div>
                <div className="flex flex-row items-center border-t border-gray-200">
                  <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                    How are your classes conducted with the present COVID-19
                    situation?
                  </div>
                  <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                    Our programmes are conducted with proper clearance from the
                    relevant Government authorities (Ministry of Education and
                    EnterpriseSG). We also abide by our Safety Management Plan,
                    which measures such as safe distancing, mandatory
                    mask-wearing, temperature-taking etc. (feel free to request
                    for a copy of our Safety Management Plan).
                    <br />
                    <br /> In the event of any COVID-19 measures, legislation,
                    or any directive from the Government disrupting the conduct
                    of the programme, there will be no refund of the fees paid.
                    Instead, the programme will be postponed to another
                    date/time (as per our Terms & Conditions in our Registration
                    Form).
                  </div>
                </div>
              </div>

              <div className="my-10 text-center">
                <NavLink
                  className="px-6 py-4 text-xl font-bold text-white rounded-xl bg-btnColor font-primary"
                  to="https://start.publicspeakingacademy.com.sg/?utm_source=mweba&utm_campaign=mweba"
                >
                  CLICK HERE TO ENROLL NOW
                </NavLink>
              </div>
              <p class="py-5 font-text text-lg">
                This may just be THE public speaking and presentation skills
                training course you need to transform your career and personal
                development! If you are ready to sign up, simply click the
                button above and the registration/payment will be processed by
                our platform (feel free to reach out to us for any queries!)
              </p>
              <p className="mt-4 mb-2 text-2xl font-bold text-center">
                Still undecided? Hear more about our S’Peak Performance
                Programme!
              </p>
              <p className="my-2 text-lg font-bold text-center">
                Hear from our past learners in Singapore!
              </p>
              <div className="flex flex-col my-10 md:space-x-5 md:flex-row">
                <div className="w-full lg:px-5 pb-10 md:w-1/2">
                  <div className="aspect-video">
                    <iframe
                      class="w-full h-full"
                      src="https://www.youtube.com/embed/3vHFhwNnhrM"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
                <div className="w-full lg:px-5 pb-10 md:w-1/2">
                  <div className="aspect-video">
                    <iframe
                      class="w-full h-full"
                      src="https://www.youtube.com/embed/FfXxW6ALzuw"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>

              <section className="my-10 bg-slate-100 rounded-xl pt-10">
                <h1 className="text-2xl font-bold mb-6 text-center">
                  Testimonials & Reviews
                </h1>
                <h2 className="text-lg font-bold mb-6 text-center lg:px-10 px-5">
                  Below are some actual, verbatim & verifiable Google reviews/
                  client testimonials extracted from our Google Business page
                  (available{" "}
                  <a
                    className="text-btnColor"
                    href="https://www.google.com/search?q=public+speaking+academy&sca_esv=b0ca21e5797e63e2&sxsrf=AE3TifPBB0t81EH94Y1iP2pUPWX0L6-vsg%3A1748515259444&source=hp&ei=uzk4aNX3GI674-EPjM_9mAg&iflsig=AOw8s4IAAAAAaDhHy6T9EiLASTavAV2pmD2fJ9M80zcZ&gs_ssp=eJzj4tVP1zc0TDcoLiqzjM8yYLRSNagwNkxJNE5JNjJPMbSwSDYytjKoSLFIMzdKskyxTEkyMTA0NvMSLyhNyslMViguSE3MzsxLV0hMTkxJza0EAJKvGFM&oq=&gs_lp=Egdnd3Mtd2l6IgAqAggAMg0QLhjHARgnGOoCGK8BMgcQIxgnGOoCMgcQIxgnGOoCMgcQIxgnGOoCMgcQIxgnGOoCMgcQIxgnGOoCMg0QLhjHARgnGOoCGK8BMgcQIxgnGOoCMg0QIxjwBRgnGMkCGOoCMgcQIxgnGOoCSOEEUABYAHABeACQAQCYAQCgAQCqAQC4AQHIAQCYAgGgAg2oAgqYAw3xBYGuWQ1nM3TnkgcBMaAHALIHALgHAMIHAzMtMcgHCg&sclient=gws-wiz#lrd="
                  >
                    here
                  </a>
                  )
                </h2>
                <TestimonialGrid testimonials={testi} />
                <h2 className="text-lg font-bold mb-6 text-center lg:px-10 px-5 pt-4 pb-10">
                  …and more!
                </h2>
              </section>

              <div className="flex flex-row my-10 space-x-5">
                <div className="w-1/2">
                  <img
                    src="/images/For-slider-1-Presentation-Skills-Training-Course-Public-Speaking-Masterclass-Workshop-World-Champion-Darren-Tay-Success-Testimonial-1024x576.png"
                    alt=""
                  />
                </div>
                <div className="w-1/2">
                  <img
                    src="/images/For-slider-2-Presentation-Skills-Training-Course-Public-Speaking-Masterclass-Workshop-World-Champion-Darren-Tay-Testimonial-1024x576.png"
                    alt=""
                  />
                </div>
              </div>

              <div className="flex flex-row my-10 space-x-5">
                <div className="w-1/2">
                  <img
                    src="/images/For-slider-3-Presentation-Skills-Training-Course-Public-Speaking-program-Workshop-World-Champion-Darren-Tay-Testimonial-1024x576.png"
                    alt=""
                  />
                </div>
                <div className="w-1/2">
                  <img
                    src="/images/For-slider-4-Presentation-Skills-Training-Course-Public-Speaking-Masterclass-Workshop-World-Champion-Darren-Testimonial-Success-1024x576.png"
                    alt=""
                  />
                </div>
              </div>
              <p className="mt-4 mb-2 text-2xl font-bold text-center">
                Know more about our track record!
              </p>
              <img
                className="my-4 text-center"
                src="/images/image showing satisfied corporate clients of s'peak performance public speaking skills training program-min.png"
                alt=""
              />
              <img
                className="my-4 text-center"
                src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-6.png"
                alt=""
              />
              <img
                className="my-4 text-center"
                src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-7.png"
                alt=""
              />

              <div>
                <h3 className="pt-5 pb-5 text-xl font-bold">
                  Relevance of this course’s training to adult learners in
                  efforts to enhance employability, job development or skills
                  upgrading:
                </h3>
                <p className="text-lg font-text">
                  <strong>S’Peak Performance Program</strong> (2-day intensive,
                  in-depth, public speaking & presentation skills training
                  course for adults) aims to impart{" "}
                  <strong>
                    actionable communication skills & presentation techniques
                  </strong>{" "}
                  to learners to achieve the following outcomes:
                </p>
                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    Enhanced non-verbal communication skills to{" "}
                    <strong>
                      speak with greater impact and clarity in the workplace
                    </strong>{" "}
                    to facilitate workplace operations, either intra or
                    cross-departmental communications
                  </li>
                  <li className="text-lg font-text">
                    Equipped with actionable public speaking & business
                    presentation skills to{" "}
                    <strong>
                      keep the audience engaged, increase knowledge retention
                    </strong>{" "}
                    and augmenting the probability of desired actions taken by
                    audience members, within the company/ organization or
                    external stakeholders.
                  </li>
                  <li className="text-lg font-text">
                    Equipped with easy-to-execute impromptu speaking frameworks
                    to{" "}
                    <strong>
                      be adequately prepared for spontaneous public speaking
                      settings,
                    </strong>{" "}
                    internal or public briefings, meetings, Q&A at seminars etc.
                  </li>
                  <li className="text-lg font-text">
                    Able to be clear and effective with spoken words and
                    articulation for{" "}
                    <strong>
                      greater clarity and impact in presentations and
                      communications.
                    </strong>
                  </li>
                  <li className="text-lg font-text">
                    Equipped with story-telling techniques to engage your
                    audience and sustain their attention:{" "}
                    <strong>
                      Make what you say more enthralling and riveting.
                    </strong>
                  </li>
                  <li className="text-lg font-text">
                    Able to <strong>lead with Charisma & Eloquence:</strong>{" "}
                    Using communication skills to influence and charm.
                  </li>
                  <li className="text-lg font-text">
                    Through blended learning (theory and practical opportunities
                    every lesson, coupled with speech recordings and evaluations
                    on-the-spot), apply actionable public speaking skills and
                    presentation techniques to workplace challenges such as
                    business presentations, recruitment interviews, change
                    management communication, professional linguistic skills in
                    order to{" "}
                    <strong>
                      equip adult learners with ready-to-use frameworks to
                      communicate tactfully, persuasively and confidently.
                    </strong>
                  </li>
                  <li className="text-lg font-text">
                    Pitch their proposals and present their corporate reports/
                    briefings with competence and influence. Equipped with
                    enhanced persuasive speaking skills and{" "}
                    <strong>
                      close business deals/ secure capital funding,
                    </strong>{" "}
                    as well as being company & brand ambassadors competent in{" "}
                    <strong>
                      promoting and strengthening the company’s brand and
                      reputational capital.
                    </strong>
                  </li>
                </ul>
              </div>

              <div className="my-10 text-center">
                <NavLink
                  className="px-6 py-4 text-xl font-bold text-white rounded-xl bg-btnColor font-primary"
                  to="https://start.publicspeakingacademy.com.sg/?utm_source=mwebb&utm_campaign=mwebb"
                >
                  CLICK HERE TO ENROLL NOW
                </NavLink>
              </div>
              <p className="my-10 text-2xl font-bold text-center">
                Join Public Speaking Academy now and elevate your public
                speaking skills!
              </p>

              <div className="bg-slate-50 p-2 md:p-10 ">
                <div className=" mb-10">
                  <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                    END OF COURSE DETAILS
                  </h1>
                  <h1 className="text-slate-500 font-primary font-bold text-center text-xl md:text-2xl">
                    Quick Tips
                  </h1>
                </div>

                <div
                  tabIndex={0}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧠 Why Do I Fear Public Speaking?
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      The fear of public speaking often comes from a mix of
                      biology, past experience, and mindset.
                    </p>
                    <p className="py-1">Here’s what’s behind it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Fight-or-flight response
                      </p>
                      <p className="font-text">
                        Speaking in public triggers adrenaline, which can cause
                        shaking, sweating, or brain freeze.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Fear of judgment
                      </p>
                      <p className="font-text">
                        You might worry about being boring, wrong, or
                        embarrassed. Fear the spotlight treatment of
                        self-perceived inadequacy (e.g. own voice).
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Past negative experiences
                      </p>
                      <p className="font-text">
                        If a past presentation went badly, your brain remembers.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">4. Perfectionism</p>
                      <p className="font-text">
                        High self-expectations can add pressure. The higher the
                        stakes (job promotion at stake), the greater the
                        expectations.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Lack of experience
                      </p>
                      <p className="font-text">
                        Like any skill, speaking gets easier with practice and
                        support.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={1}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    💬 How to Build Confidence in Adult Introverts for
                    Presentations
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Introverts can be powerful presenters—when they learn to
                      harness calm, focused communication.
                    </p>
                    <p className="py-1">Here’s how to improve:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Reframe the purpose
                      </p>
                      <p className="font-text">
                        Shift focus to how your speech is going to benefit the
                        audience, not performing for them or for them to judge
                        you.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Prepare and practice deeply
                      </p>
                      <p className="font-text">
                        Introverts tend to thrive with structure. Rehearse until
                        the content feels second nature. Internalize with
                        sign-posting (…after delivering the <b>‘challenges’</b>,
                        now comes the <b>‘solutions’</b>…)
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Use strengths like clarity and thoughtfulness
                      </p>
                      <p className="font-text">
                        You don’t have to be flashy. A quiet, well-paced
                        delivery can be just as compelling.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Start with low-pressure settings
                      </p>
                      <p className="font-text">
                        Try small team meetings, Zoom calls, or one-on-one
                        presentations first.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Learn breathing and grounding techniques
                      </p>
                      <p className="font-text">
                        Simple tools like pursed-lips breathing (Feeling the
                        cool air up the nose when inhaling, and slowly exhaling
                        with pursed lips) or pausing with sustained eye contact
                        before you speak can keep nerves in check.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={2}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    💼 Public Speaking Skills for Career Success
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Strong speaking skills can set you apart
                      professionally—whether you’re interviewing, managing, or
                      leading.
                    </p>
                    <p className="py-1">
                      Here’s how public speaking supports career growth:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Enhances communication
                      </p>
                      <p className="font-text">
                        You articulate ideas more clearly and confidently. This
                        is excellent for your audience.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Increases visibility
                      </p>
                      <p className="font-text">
                        Speaking up in meetings or events raises your profile,
                        and be perceived as a ready contributor.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Builds leadership presence
                      </p>
                      <p className="font-text">
                        Confident speakers are often seen as potential leaders.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Improves persuasion
                      </p>
                      <p className="font-text">
                        You can influence others with clarity and conviction,
                        hence either open doors for you or mitigate
                        confrontation.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Supports career transitions
                      </p>
                      <p className="font-text">
                        From job interviews to pitching ideas—speaking well
                        gives you an edge to land your dream job or promotion.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={3}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    📖 Storytelling Techniques for Public Speaking
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Great storytelling makes your message memorable and
                      emotional.
                    </p>
                    <p className="py-1">Here's how to do it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Start with a hook
                      </p>
                      <p className="font-text">
                        Draw the audience in right away with a vivid moment or
                        conflict. E.g. A startling statistic, quotation, or
                        short story.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Follow a structure
                      </p>
                      <p className="font-text">
                        Use the classic arc: beginning (set the scene and
                        characters), buildup (the obstacles and challenges
                        faced), climax (the tipping point), resolution (lesson
                        learnt).
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Keep it personal
                      </p>
                      <p className="font-text">
                        Authentic stories connect more than generic ones.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Use descriptive language
                      </p>
                      <p className="font-text">
                        Help the audience see, hear, and feel what happened.
                        Show and not tell. “Creased eyebrows and flared
                        nostrils” to convey “I was angry”.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. End with meaning
                      </p>
                      <p className="font-text">
                        Tie your story back to your point or a lesson learned.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={4}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🌟 What Speaking Skills Make a Good Leader?
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Leaders aren’t just good at speaking—they’re great at
                      connecting. Here are the key speaking skills that set
                      leaders apart:
                    </p>
                    <p className="py-1">Here’s how to grow it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">1. Clarity</p>
                      <p className="font-text">
                        They express ideas simply and logically.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">2. Empathy</p>
                      <p className="font-text">
                        They speak in ways that resonate with how people feel
                        and what they need.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Active listening
                      </p>
                      <p className="font-text">
                        Great leaders listen to others with the intent to
                        surface underlying concerns/ interests, and therefore
                        are able to respond with pinpoint relevance.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">4. Inspiration</p>
                      <p className="font-text">
                        They use tone, stories, and vision to spark motivation.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">5. Presence</p>
                      <p className="font-text">
                        They hold space—through eye contact, pauses, and calm
                        energy.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={5}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    💼 How to Develop Executive Presence
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Executive presence is that "something" that makes people
                      stop and listen—it’s a mix of communication, confidence,
                      and calm.
                    </p>
                    <p className="py-1">Here’s how to build it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Speak with confidence
                      </p>
                      <p className="font-text">
                        Use a steady pace, strong voice, and clear structure
                        when you talk. Pause if need be, instead of using pause
                        fillers.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Master non-verbal signals
                      </p>
                      <p className="font-text">
                        Stand tall (chest upright & outwards), make sustained
                        eye contact, and use purposeful gestures.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Listen before you speak
                      </p>
                      <p className="font-text">
                        Show respect by tuning in, then responding thoughtfully.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Stay composed, and always be clear on core interests
                        whilst under pressure
                      </p>
                      <p className="font-text">
                        When things get tough, your calm energy sets the tone.
                        Never lose sight of your organization’s core interests
                        even when sense of urgency is required.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Lead with vision
                      </p>
                      <p className="font-text">
                        Speak not just to inform—but to inspire.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={6}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧭 Is Public Speaking a Leadership Skill?
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Yes—<b>public speaking is a core leadership skill</b>.
                      Leaders need to inform, inspire, and influence others—and
                      strong speaking skills help make that happen.
                    </p>
                    <p className="py-1">Here’s why it matters:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Builds trust and credibility
                      </p>
                      <p className="font-text">
                        Clear, confident speech helps leaders earn respect and
                        command attention.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Clarifies vision and direction
                      </p>
                      <p className="font-text">
                        Great leaders communicate goals and values in a way that
                        rallies others to act.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Inspires and motivates
                      </p>
                      <p className="font-text">
                        Storytelling, tone, and presence can ignite team morale
                        and momentum.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Navigates tough conversations
                      </p>
                      <p className="font-text">
                        Whether it’s delivering feedback or handling crisis,
                        effective speaking keeps people aligned.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Boosts influence and visibility
                      </p>
                      <p className="font-text">
                        The ability to speak well in public settings—from
                        meetings to keynotes—amplifies leadership impact.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={7}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🔁 Difference Between Impromptu and Prepared Speech
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      <b>Impromptu speeches</b> are delivered with little to no
                      preparation—think of answering a surprise question in
                      class or during a meeting.
                      <br />
                      <b>Prepared speeches</b> are written, practiced, and
                      rehearsed ahead of time—like a TED Talk or school
                      classroom/ business/ boardroom presentation.
                    </p>
                    <p className="py-1">Here’s a quick comparison:</p>
                    <div className="py-5">
                      <table className="table-auto w-full text-left border">
                        {/* head */}
                        <thead>
                          <tr className="bg-slate-200">
                            <th>Aspect</th>
                            <th>Impromptu Speech</th>
                            <th>Prepared Speech</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* row 1 */}
                          <tr>
                            <td>Planning time</td>
                            <td>Minimal or none</td>
                            <td>Ample time to plan</td>
                          </tr>
                          {/* row 2 */}
                          <tr>
                            <td>Structure</td>
                            <td>Often spontaneous</td>
                            <td>Clear and deliberate</td>
                          </tr>
                          {/* row 3 */}
                          <tr>
                            <td>Delivery</td>
                            <td>Natural, conversational</td>
                            <td>Polished, rehearsed</td>
                          </tr>
                          {/* row 4 */}
                          <tr>
                            <td>Examples</td>
                            <td>Q&A sessions, interviews, oral exams</td>
                            <td>Keynotes, speeches, presentations</td>
                          </tr>
                          {/* row 5 */}
                          <tr>
                            <td>Skill focus</td>
                            <td>Thinking fast on your feet</td>
                            <td>Clarity, depth, delivery style</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p className="py-1">
                      Both styles build different communication muscles—and
                      strong speakers often train in both.
                    </p>
                  </div>
                </div>

                <div
                  tabIndex={8}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧩 What Are Effective Public Speaking Techniques for Sales
                    Professionals
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Sales professionals rely on strong speaking skills to
                      build trust and close deals.
                    </p>
                    <p className="py-1">
                      Here’s how to speak more persuasively in sales settings:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Focus on the listener's needs
                      </p>
                      <p className="font-text">
                        Start with their pain points—not your product. Frame
                        your message as a solution (instead of harping on
                        features, focus on benefits; e.g. the AI-assisted app
                        feature can save 30% time and cost, boosting
                        productivity)
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Use clear, benefit-driven language
                      </p>
                      <p className="font-text">
                        Explain how your product helps in real-world terms.
                        Avoid jargon.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Tell client success stories
                      </p>
                      <p className="font-text">
                        Share short, authentic testimonials of how others
                        benefited.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Practice objection handling
                      </p>
                      <p className="font-text">
                        Stay calm when prospects push back—acknowledge, decipher
                        underlying concerns, answer, and refocus.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Project confidence and energy
                      </p>
                      <p className="font-text">
                        Your tone (reassuring), posture (ready to serve), and
                        sustained eye contact all help build rapport.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={9}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧑🏫 Public Speaking Tips for Educators
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Whether you're in a classroom or on stage, educators need
                      to keep people engaged and informed.
                    </p>
                    <p className="py-1">
                      Here’s how to level up your speaking:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Start with a strong hook
                      </p>
                      <p className="font-text">
                        Open with a question (hand raised to arouse students’
                        participation), image, or fact to draw learners in.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Break ideas into chunks
                      </p>
                      <p className="font-text">
                        Use structure and transitions to guide understanding.
                        Use sign-posts to boost knowledge retention – “Having
                        dealt with the challenges we face, we now move on to the
                        solutions!”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Vary your tone and pace
                      </p>
                      <p className="font-text">
                        Keep things lively—avoid monotone delivery. Firm when
                        delivering facts and challenges ahead, vigorous when
                        delivering future plans!
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Engage with questions
                      </p>
                      <p className="font-text">
                        Ask, pause, and invite responses to keep attention.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Use stories to explain concepts
                      </p>
                      <p className="font-text">
                        Real-life analogies and classroom anecdotes make lessons
                        stick. “Facts tell, Stories sell.”
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={10}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    💼 Public Speaking Tips for Self-Employed Professionals
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Entrepreneurs, freelancers, and solo practitioners often
                      pitch, network, and lead—all through communication.
                    </p>
                    <p className="py-1">
                      Here’s how to make your voice work for your brand:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Sharpen your elevator pitch
                      </p>
                      <p className="font-text">
                        Be ready with a clear, confident intro of who you help
                        and how (stand out by portraying yourself as a problem
                        solver).
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Create content with your voice
                      </p>
                      <p className="font-text">
                        Webinars, podcasts, or workshops let you show expertise
                        and build trust.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Share your story
                      </p>
                      <p className="font-text">
                        Your journey matters—use it to connect with audiences
                        and clients.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Learn to pitch persuasively
                      </p>
                      <p className="font-text">
                        Structure, delivery (talking about the product/
                        service’s benefits instead of features), and
                        call-to-action are key in proposals and presentations.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Show up consistently
                      </p>
                      <p className="font-text">
                        Your tone, posture, and messaging should align across
                        all platforms.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={6}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🎯 Presentation Skills Training Course for Adults
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      <b>A presentation skills training course for adults</b>{" "}
                      helps professionals communicate clearly, confidently, and
                      persuasively—whether in meetings, on stage, or online. It
                      should offer a deep-dive into public speaking and business
                      presentation techniques, tailored to the modern working
                      adult.
                    </p>
                    <p className="py-1">
                      Here’s what a good presentation course typically covers:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Building speaking confidence
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            Teaches effective power poses you can use to
                            overcome stage fright and business presentation
                            anxieties.
                          </li>
                          <li className="list-disc">
                            Guides students through step-by-step visualization
                            method to be consistently confident in public
                            speaking settings.
                          </li>
                          <li className="list-disc">
                            How to rehearse & practice like the top professional
                            speakers.
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Structuring a compelling presentation
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            How to compose an attention-grabbing story
                          </li>
                          <li className="list-disc">
                            The secrets to delivering powerful powerpoint
                            presentation without reading off the slides
                          </li>
                          <li className="list-disc">
                            The "8-step Edge of the seat" formula that keeps
                            peoples listening attentively plus 2 speech genres
                            (persuasive and informative speech)
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Improving vocal delivery and body language
                      </p>
                      <p className="font-text">
                        Have adult learners practice eye contact, tone
                        variation, gestures, and posture to create presence.
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            Hand gestures,power poses, stage positioning fright
                          </li>
                          <li className="list-disc">
                            How to have stage presence with proper eye contact
                            (learn about the wide angle of attack and eye
                            contact distribution)
                          </li>
                          <li className="list-disc">
                            The power of incorporating pauses in your
                            presentation
                          </li>
                          <li className="list-disc">
                            Facial expressions you should avoid using
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Practising with real exposure to unfamiliar audience
                      </p>
                      <p className="font-text">
                        Deliver speeches in breakout sessions & final showcase
                        to accumulate stage mileage, in front of classmates from
                        all walks of life, get insightful trainer’s feedback,
                        and apply techniques in work-related contexts.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Personalized feedback/ evaluation
                      </p>
                      <p className="font-text">
                        The best presentation skills training programs offer
                        personalized guidance and evaluation to help you improve
                        & develop faster.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden lg:inline lg:w-1/3 px-5 pt-5 mb-10 border border-dashed rounded-lg">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
